import React, { useState, useRef, useEffect } from 'react';
import IntegrationModal from '../Modals/IntegrationModal';
import images from '../../images';

const IntegrationCard = ({ integration, showActions = true, onIntegrationUpdated, userData }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [copyNotificationVisible, setCopyNotificationVisible] = useState(false);
  const handleCopyUrl = () => {
    if (integration.url) {
      navigator.clipboard.writeText(integration.url)
        .then(() => {
          setCopyNotificationVisible(true);
          setTimeout(() => {
            setCopyNotificationVisible(false);
          }, 1500);
        })
        .catch(err => {
          console.error('Ошибка при копировании URL:', err);
        });
    }
  };

  const countParameters = Object.keys(integration.param || {}).filter(key => integration.param[key]).length;

  const handleEditIntegration = () => {
    console.log('IntegrationCard: Opening modal with integration:', integration);
    setSelectedIntegration(integration);
    setIsModalOpen(true);
    setShowDropdown(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedIntegration(null);
  };

  const handleIntegrationUpdated = () => {
    if (onIntegrationUpdated) {
      onIntegrationUpdated();
    }
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <div className="integration-card">
      <div className="integration-card-header">
        <h3 className="integration-card-title">{integration.name || integration.param.name}</h3>
        {!showActions && <div className="integration-card-dots-placeholder" />}
        {showActions && (
          <div className="btn-group dropstart" ref={dropdownRef}>
            <button
              type="button"
              className="dropdown integration-card-dots"
              // onClick={() => setShowDropdown(!showDropdown)}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              ⋮
            </button>
            <ul className={`dropdown-menu integration-dropdown-block ${showDropdown ? 'show' : ''}`}>
              <li>
                <button className="dropdown-item integration-card-edit-btn" onClick={handleEditIntegration}>
                  <img src={images.penLinear} alt="edit" className="edit-icon" />
                  Изменить
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
      
      <div className="integration-card-content">
        {integration.packages && integration.packages.length > 0 && (
          <div className="integration-packages">
            {integration.packages.join(', ')}
          </div>
        )}

        <div className="integration-flows-and-parameters">
          <div className="integration-flows">
            {integration.flows && integration.flows.length > 0 && (
              integration.flows.map((flow, index) => (
                <span key={index} className="integration-flow-badge" style={{ backgroundColor: '#3745AF' }}>
                  {flow.flow_guide_name}
                </span>
              ))
            )}
          </div>
          
          <div className="integration-parameters">
            {countParameters} параметра
          </div>
        </div>
        
        {integration.url && (
          <div
            className="integration-url"
            onClick={handleCopyUrl}
          >
            {integration.url}
            <img
              src={images.copyLinear}
              alt="copy"
              className="copy-icon"
              onClick={(e) => {
                e.stopPropagation();
                handleCopyUrl();
              }}
            />
          </div>
        )}
        {copyNotificationVisible && (
        <div className="copy-notification-overlay">
          Скопировано!
        </div>
      )}
      </div>

      <IntegrationModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onIntegrationCreated={handleIntegrationUpdated}
          integration={selectedIntegration}
          userData={userData}
      />

    </div>
  );
};

export default IntegrationCard;
